// import { $get, $post, $patch, $put, $delete } from '_library/ajax'
import { $get, $post } from '_library/ajax'

const list = {
  'device-patrol-send-message': '/patrol/device/send-message',
  'device-patrol-patrol-remark': '/patrol/device/patrol-remark',
  'device-patrol-volume-control': '/patrol/device/volume-control',
  'device-patrol-remote-shouting': '/patrol/device/remote-shouting',
  'device-patrol-patrol-screenshot': '/patrol/device/patrol-screenshot',
  'device-patrol-camera-screenshot': '/patrol/device/camera-screenshot',
  'patrol-record-page-list': '/patrol/record/page-list',
}

const methods = {
  devicePatrolSendMessage: data => $post('device-patrol-send-message', data), // 设备巡视-发布消息
  devicePatrolPatrolRemark: data => $post('device-patrol-patrol-remark', data), // 设备巡视-巡视备注
  devicePatrolVolumeControl: data =>
    $post('device-patrol-volume-control', data), // 设备巡视-音量调节
  devicePatrolPatrolScreenshot: data =>
    $post('device-patrol-patrol-screenshot', data), // 设备巡视-巡视截图
  devicePatrolRemoteShouting: data =>
    $post('device-patrol-remote-shouting', data), // 设备巡视-远程喊话
  devicePatrolCameraScreenshot: data =>
    $post('device-patrol-camera-screenshot', data), // 摄像头截图
  patrolRecordPageList: data => $get('patrol-record-page-list', data), // 巡视记录-获取巡视记录分页列表
}

export default { list, methods }
